/**
* Created by lobin on 2020/10/28.
*/
<template>
  <div class="partner-white-list">
    <a-modal
        width="690px"
        title="快递员白名单设置"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <p>白名单：<a-switch
          checked-children="开启"
          un-checked-children="关闭"
          default-checked v-model="partnerWhiteListTip"
      /></p>
      <p v-if="partnerWhiteListTip">
        <a-transfer
            :titles="['在本站投递的快递员', '投递白名单']"
            :list-style="{
              width: '300px',
              height: '300px',
            }"
            :data-source="dataList"
            show-search
            :filter-option="filterOption"
            :target-keys="targetKeys"
            :render="renderItem"
            @change="handleChange"
            @search="handleSearch"
        />
      </p>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { stationModify, stationDetail } from '@/api/station';
import { stationPartnerList } from '../../api/user';

export default {
  data() {
    return {
      visible: false,
      id: '',
      confirmLoading: false,
      dataList: [],
      targetKeys: [],
      partnerWhiteListTip: false,
    };
  },
  methods: {
    handleOk() {
      this.modifystation();
    },
    handleCancel() {
      this.visible = false;
      this.dataList = [];
      this.targetKeys = [];
      this.id = '';
    },
    show(id) {
      this.id = id;
      this.getData();
      this.getDetail();
      this.visible = true;
    },
    async getData() {
      const { data } = await stationPartnerList(this.id);
      this.dataList = data;
    },
    async modifystation() {
      this.confirmLoading = true;
      await stationModify(this.id, {
        partnerWhiteListTip: this.partnerWhiteListTip,
        partnerWhiteList: this.targetKeys,
      });
      this.confirmLoading = false;
      this.$message.success('修改成功');
      this.visible = false;
      this.dataList = [];
      this.targetKeys = [];
      this.id = '';
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys) {
      this.targetKeys = targetKeys;
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value);
    },
    async getDetail() {
      const { data } = await stationDetail(this.id);
      this.partnerWhiteListTip = data.partnerWhiteListTip;
      this.targetKeys = data.partnerWhiteList;
    },
    renderItem(item) {
      const customLabel = (
          <span class="custom-item">
            <a-avatar size={22} icon="user" src={item.headimgurl} style="margin-right:5px"/>
          ({item.num}){item.title}{item.mobile ? ` - ${item.mobile}` : item.mobile}
        </span>
      );
      return {
        label: customLabel, // for displayed item
        value: item.title + item.mobile ? ` - ${item.mobile}` : item.mobile, // for title and filter matching
      };
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.partner-white-list {

}
</style>
